
webpack.register(
    'components/brightcove-video/brightcove-video',
    function() {
        return require('components/brightcove-video/brightcove-video');
    },
    false
);
webpack.register(
    'components/image-universal/image-universal',
    function() {
        return require('components/image-universal/image-universal');
    },
    false
);
webpack.register(
    'components/social-share/social-share',
    function() {
        return require('components/social-share/social-share');
    },
    false
);
var stache = require('can/view/stache/stache');
module.exports = stache("<can-import from='components/brightcove-video/brightcove-video'/>\r\n<can-import from='components/image-universal/image-universal'/>\r\n<can-import from='components/social-share/social-share'/>\r\n\r\n<div class=\"s-tag-based-related-content-slider-item__video-card {{#if isPlaying}}is-playing{{/if}}\">\r\n    <div class=\"s-tag-based-related-content-slider-item__container\">\r\n        <brightcove-video autoplay=\"false\" muted=\"true\" {video-id}=\"data.video.identifier\" playsinline=\"true\"/>\r\n        <div class=\"s-tag-based-related-content-slider-item__container s-tag-based-related-content-slider-item__container--inner s-tag-based-related-content-slider-item__container--column\">\r\n            <div class=\"s-tag-based-related-content-slider-item__text s-tag-based-related-content-slider-item__text--cut\">\r\n                {{data.title}}\r\n            </div>\r\n            {{#if data.video.shareUrl}}\r\n                <a href=\"{{data.video.shareUrl}}#!&video=start\" class=\"s-tag-based-related-content-slider-item__link\">\r\n                    Watch More\r\n                </a>\r\n            {{/if}}\r\n        </div>\r\n    </div>\r\n</div>\r\n");